var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIntegracao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30493 10.9135L6.18925 14.3089M13.5783 7.51808L15.694 10.9135M16.1571 17.0014H11.9995M9.07857 5.00072C9.07857 3.34411 10.3859 2 11.9995 2C13.612 2 14.9204 3.34303 14.9204 5.00072C14.9204 6.65734 13.6131 8.00144 11.9995 8.00144C10.3859 7.99928 9.07857 6.65625 9.07857 5.00072ZM2 16.9993C2 15.3427 3.3073 13.9986 4.9209 13.9986C6.53345 13.9986 7.8418 15.3416 7.8418 16.9993C7.84074 18.6559 6.5345 20 4.9209 20C3.3073 20 2 18.657 2 16.9993ZM16.1582 16.9993C16.1582 15.3427 17.4655 13.9986 19.0791 13.9986C20.6916 13.9986 22 15.3416 22 16.9993C22 18.6559 20.6927 20 19.0791 20C17.4644 20 16.1582 18.657 16.1582 16.9993Z",
    stroke: "#0A9E5A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegracao);
export default __webpack_public_path__ + "static/media/icon-integracao.f59c051dfd243de129860e6a6b836876.svg";
export { ForwardRef as ReactComponent };